import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, UserCheck } from "lucide-react";
import { useFundingCta } from "./FundingCta";

/**
 * Shown only when someone arrives on an introducer's own explainer link. Their client knows
 * their name, so saying it out loud is the trust signal — and it makes clear who stays involved.
 */
export default function FundingIntroBar() {
  const { introducer, applyHref } = useFundingCta();
  if (!introducer?.name) return null;

  return (
    <div className="relative z-10 border-b border-white/10 bg-white/[0.04] backdrop-blur-sm" data-testid="funding-intro-bar">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-3 sm:py-3.5 flex flex-col sm:flex-row sm:items-center gap-2.5 sm:gap-5">
        <div className="flex items-start gap-2.5 min-w-0 flex-1">
          <UserCheck className="size-4 text-[#7da9ff] mt-[3px] shrink-0" />
          <p className="text-[13px] leading-snug text-slate-400">
            Sent to you by <span className="font-semibold text-white" data-testid="funding-intro-name">{introducer.name}</span>
            <span className="hidden sm:inline"> — you apply to our desk, and they stay in the loop the whole way through.</span>
            <span className="sm:hidden"> — they stay in the loop the whole way through.</span>
          </p>
        </div>
        {applyHref && (
          <Link to={applyHref} data-testid="funding-intro-bar-apply"
                className="group shrink-0 inline-flex items-center justify-center gap-2 h-10 px-4 rounded-full border border-white/20 hover:border-white/40 hover:bg-white/[0.06] text-white text-[13px] font-semibold transition-colors">
            Start your application
            <ArrowRight className="size-3.5 transition-transform duration-300 group-hover:translate-x-0.5" />
          </Link>
        )}
      </div>
    </div>
  );
}
